import { FunctionComponent, useContext, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import "react-datepicker/dist/react-datepicker.css";
import { globalContext } from "../../../../Provider/AppProvider";
import images from "../../../../assets/images/index";
import styles from "./FilterDropdown.module.css";
import { GET_LEAGUES_LIST } from "../../../../features/Tickets/api/TicketsQuery";
import { DateFilter, LeagueListMenu, ResetApplyButtons, convertStringToDate, extractLeagues, formatDateWithHyphen, showCustomRange } from "../../../../helper";
import FilterTitle from "./FilterTitle";

interface FilterDropdownProps {
  activetab ?: number
  handleCloseFilterDropDown: () => void
}

interface LeagueObjectType{
  l_id: string,
  l_name: string,
}
interface LeaguesList{
    leagues: LeagueObjectType[]
}

const DelistAndUnsoldFilterDropdown: FunctionComponent<FilterDropdownProps> = ({handleCloseFilterDropDown}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [unsoldFilterStartDate,setUnsoldFilterStartDate] = useState<string | null>(null);
  const [unsoldFilterEndDate, setUnsoldFilterEndDate] = useState<string | null>(null);
  const [unsoldFilterStartDateRange,setUnsoldFilterStartDateRange] = useState<string | null>(null);
  const [unsoldFilterEndDateRange, setUnsoldFilterEndDateRange] = useState<string | null>(null);
  const [unsoldFilterLeagueId,setUnsoldFilterLeagueId] = useState<string | null>(globalState.unsoldTicketFilter.leagueId || null);
  const {dropdownIcon} = images;
  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
  const [unsoldLeague , setUnsoldLeague] = useState<string>(globalState.unsoldTicketFilter.leagueName || "")
  const [days, setDays] = useState<string>(globalState.unsoldTicketFilter.selectedDateValue || "")
  const [startDateUnsold, setStartDateUnsold] = useState<any>('');
  const [endDateUnsold, setEndDateUnsold] = useState<any>('');
  const [showDatePickerUnsold, setShowDatePickerUnsold] = useState<boolean>(false);
  const [customRangeUnsold, setCustomrangeUnsold] = useState<boolean>(false);

const [leagueslistDataInUnsold,setLeaguesListInUnsold] = useState<LeaguesList>();

  const [getLeaguesListForUnsoldFilter] = useLazyQuery(GET_LEAGUES_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if(data){
        const extractedData = data?.leagues
        ?.filter((item: LeagueObjectType) => !extractLeagues.includes(item?.l_name))
        .map((result:LeagueObjectType) => result);
        setLeaguesListInUnsold(extractedData);
      }
    }
   });

  const handleClickOpenMenu = (e: React.MouseEvent<HTMLInputElement>) =>{
    setAnchorEl(e.currentTarget);
    getLeaguesListForUnsoldFilter();
  }

  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  const handleSelectleague = (league: LeagueObjectType) =>{
    setUnsoldLeague(league?.l_name);
    setUnsoldFilterLeagueId(league?.l_id);
    setAnchorEl(null)
  }

  const handleCancel = () =>{
    const tempData = {...globalState};
    tempData.unsoldTicketFilter.isFilter = false;
    tempData.unsoldTicketFilter.leagueId = null;
    tempData.unsoldTicketFilter.leagueName = '';
    tempData.unsoldTicketFilter.ticketStatus = null;
    tempData.unsoldTicketFilter.startdate = null;
    tempData.unsoldTicketFilter.enddate = null;
    tempData.unsoldTicketFilter.startDateRange = null;
    tempData.unsoldTicketFilter.endDateRange = null;
    tempData.unsoldTicketFilter.selectedDateValue = '';
    tempData.unsoldTicketFilter.isCustomRange = false;
    tempData.unsoldTicketFilter.clicked = true;

    handleGlobalState(tempData);
    setUnsoldLeague("")
    setDays("")
    setStartDateUnsold("");
    setEndDateUnsold("");
    setUnsoldFilterStartDate(null);
    setUnsoldFilterEndDate(null);
    setUnsoldFilterStartDateRange(null);
    setUnsoldFilterEndDateRange(null);
    setUnsoldFilterLeagueId(null);
    setShowDatePickerUnsold(false)
    setCustomrangeUnsold(false)
  }

  const handleClickDays = (day: string) =>{
    setStartDateUnsold('');
    setEndDateUnsold('');
    setUnsoldFilterStartDateRange(null);
    setUnsoldFilterEndDateRange(null);
    const {startdate,enddate} = convertStringToDate(day);
    setUnsoldFilterStartDate(startdate);
    setUnsoldFilterEndDate(enddate);
    setDays(day);
  }

  const unsoldDatePickerChange = (dates: [start: Date,end: Date]) => {
    const [start, end] = dates; 
    setUnsoldFilterStartDate(null);
    setUnsoldFilterEndDate(null);
    setUnsoldFilterStartDateRange(start  && formatDateWithHyphen(start));
    setUnsoldFilterEndDateRange(end && formatDateWithHyphen(end));
    setStartDateUnsold(start);
    setEndDateUnsold(end);
    setDays('')
    setCustomrangeUnsold(false)
  };

  const handleClickUnsoldCustomRange = () =>{
    setShowDatePickerUnsold(true)
    setDays('')
    setCustomrangeUnsold(false);
  }

  const handleClickUnsoldDatePickerOutside = () =>{
    setShowDatePickerUnsold(false)
    setCustomrangeUnsold(true)
    setDays('')
    if(endDateUnsold === null){
      setUnsoldFilterEndDateRange(startDateUnsold && formatDateWithHyphen(startDateUnsold));
      setEndDateUnsold(startDateUnsold)
    }
  }

const showDayTick = () => {
  if(unsoldFilterStartDateRange && unsoldFilterEndDateRange){
    return '';
  }else {
    if(days === '' && globalState.unsoldTicketFilter.selectedDateValue === ''){
      return '';
    }else if(days){
      return days;
    }else if(globalState.unsoldTicketFilter.selectedDateValue){
      return globalState.unsoldTicketFilter.selectedDateValue;
    }
  }
}

const showCustomRangeValues = () => {
  if(unsoldFilterStartDate){
     return '';
  }else {
    if(customRangeUnsold === false && globalState.unsoldTicketFilter.isCustomRange === false){
      return;
     }else if(customRangeUnsold){
       return (<span className={styles.dateformat}>{showCustomRange(startDateUnsold,endDateUnsold,"delistandunsold",globalState)}</span>);
     }else if(globalState.unsoldTicketFilter.isCustomRange){
       return (<span className={styles.dateformat}>{showCustomRange(startDateUnsold,endDateUnsold,"delistandunsold",globalState)}</span>);
     }
  }
}
const handleSubmitFilter = () => {
  const tempData = {...globalState};
  if(unsoldFilterLeagueId || unsoldFilterStartDate || unsoldFilterStartDateRange){
    tempData.unsoldTicketFilter.isFilter = true;
    tempData.unsoldTicketFilter.clicked = true;
  }
  if(unsoldFilterStartDateRange && unsoldFilterEndDateRange){
    tempData.unsoldTicketFilter.startdate = null;
    tempData.unsoldTicketFilter.enddate = null;
    tempData.unsoldTicketFilter.startDateRange = unsoldFilterStartDateRange ? unsoldFilterStartDateRange : globalState.unsoldTicketFilter.startDateRange;
    tempData.unsoldTicketFilter.endDateRange = unsoldFilterEndDateRange ? unsoldFilterEndDateRange : globalState.unsoldTicketFilter.endDateRange;
  }else{
    if(days === 'Today' || days === 'Yesterday'){
      tempData.unsoldTicketFilter.startdate = unsoldFilterStartDate ? unsoldFilterStartDate : globalState.unsoldTicketFilter.startdate;
      tempData.unsoldTicketFilter.enddate = null;
      tempData.unsoldTicketFilter.startDateRange = null;
      tempData.unsoldTicketFilter.endDateRange = null;
    }else {
      if(globalState.unsoldTicketFilter.startDateRange && globalState.unsoldTicketFilter.endDateRange){
         if(unsoldFilterStartDate && unsoldFilterEndDate){
          tempData.unsoldTicketFilter.startdate = unsoldFilterStartDate ? unsoldFilterStartDate : globalState.unsoldTicketFilter.startdate;
          tempData.unsoldTicketFilter.enddate = unsoldFilterEndDate ? unsoldFilterEndDate : globalState.unsoldTicketFilter.enddate ;
          tempData.unsoldTicketFilter.startDateRange = null;
          tempData.unsoldTicketFilter.endDateRange = null;
         }else{
          tempData.unsoldTicketFilter.startdate = null;
          tempData.unsoldTicketFilter.enddate = null;
          tempData.unsoldTicketFilter.startDateRange = unsoldFilterStartDateRange ? unsoldFilterStartDateRange : globalState.unsoldTicketFilter.startDateRange;
          tempData.unsoldTicketFilter.endDateRange = unsoldFilterEndDateRange ? unsoldFilterEndDateRange : globalState.unsoldTicketFilter.endDateRange;
         }
      }else{
        tempData.unsoldTicketFilter.startdate = unsoldFilterStartDate ? unsoldFilterStartDate : globalState.unsoldTicketFilter.startdate;
        tempData.unsoldTicketFilter.enddate = unsoldFilterEndDate ? unsoldFilterEndDate : globalState.unsoldTicketFilter.enddate ;
        tempData.unsoldTicketFilter.startDateRange = null;
        tempData.unsoldTicketFilter.endDateRange = null;
      }
    }   
  }
  tempData.unsoldTicketFilter.leagueId = unsoldFilterLeagueId;
  tempData.unsoldTicketFilter.leagueName = unsoldLeague;
  tempData.unsoldTicketFilter.selectedDateValue = days;
  if(unsoldFilterStartDateRange && unsoldFilterEndDateRange){
  tempData.unsoldTicketFilter.isCustomRange = true;
  }
  handleGlobalState(tempData);
  handleCloseFilterDropDown();
}

  return (
    <div className={styles.filterDropdownUnsold}>
      <div className={styles.top}>
        <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDown}/>
        <div className={styles.filterContainerUnsold}>
          <div className={styles.container}>
            <div className={styles.filterDetails}>
              <div className={styles.textFieldFullMain}>
                <div className={styles.titlePlaceholder}>
                  <b className={styles.event}>Event</b>
                </div>
                <div className={styles.textField} onClick={handleClickOpenMenu}>
                  <div className={styles.container1}>
                    <div
                      className={
                        unsoldLeague === "" ? styles.select : styles.leagueSelect
                      }
                    >
                      {unsoldLeague ? unsoldLeague : '--Select--'}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt="dropdownIcon"
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>
              <DateFilter 
                handleClickDays={handleClickDays}
                showDayTick={showDayTick} 
                handleClickCustomRange={handleClickUnsoldCustomRange}
                showCustomRangeValues={showCustomRangeValues} 
                showDatePicker={showDatePickerUnsold} 
                startDate={startDateUnsold}
                endDate={endDateUnsold}
                handleClickOutside={handleClickUnsoldDatePickerOutside} 
                onChange={unsoldDatePickerChange}
              />
            </div>
          </div>
          <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitFilter}/>
        </div>
      </div>
       <LeagueListMenu
        anchorEl ={anchorEl}
        open= {open}
        selectedLeague = {unsoldLeague}
        handleCloseMenu ={handleCloseMenu}
        handleSelectleague={handleSelectleague}
        leagueslistData = {leagueslistDataInUnsold}
      />
    </div>
  );
};

export default DelistAndUnsoldFilterDropdown;
